export default function formatCurrency(
  number: number,
  locals = 'en-US'
): string {
  const numericValue = typeof number === 'string' ? parseFloat(number) : number;

  let currency = 'USD';

  switch (locals) {
    case 'en-CA':
      currency = 'CAD';
      break;
    case 'en-GB':
      currency = 'GBP';
      break;
    case 'de-DE':
      currency = 'EUR';
      break;
    default:
  }

  return new Intl.NumberFormat(locals, { style: 'currency', currency }).format(
    numericValue
  );
}
